// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0afe5811","732":"12842cb6","977":"13fe689e"}[chunkId] + ".chunk.js";
};